import {
  INICIAR_VENTANA_TRAZADORA,
  SET_VISIBLE,
} from '../constants/trazadora.constants';

export const setVisible = payload => ({
  type: SET_VISIBLE,
  payload,
});

export const iniciarVentanaTrazadora = params => ({
  type: INICIAR_VENTANA_TRAZADORA,
  payload: params,
});
